<template>
  <div>
    <el-steps :active="active" :align-center="true" finish-status="finish">
      <el-step
        v-for="item in stepList"
        :key="item.title"
        :title="item.title"
      ></el-step>
    </el-steps>
  </div>
</template>
<script>
export default {
  props: {
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      stepList: [
        { title: '企业基本信息输入' },
        { title: '企业信息人工审核' },
        { title: '银行开户审核' },
        { title: '开户成功' }
      ]
    };
  }
};
</script>
